// Inline SVG Tulsi wordmark. Uses brand gradient. No external asset required.
export function TulsiLogo({ size = 40, showWord = true, className = "" }) {
  const id = `tulsi-grad-${size}`;
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Tulsi Tea"
        role="img"
      >
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#E5197F" />
            <stop offset="100%" stopColor="#6D2C91" />
          </linearGradient>
        </defs>
        <rect x="0" y="0" width="64" height="64" rx="16" fill={`url(#${id})`} />
        {/* Simplified tea-leaf glyph */}
        <path
          d="M20 44 C 20 26, 34 20, 46 20 C 46 34, 38 44, 24 46 Z"
          fill="#FFD93D"
        />
        <path d="M22 44 C 30 36, 38 30, 46 20" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round" />
      </svg>
      {showWord && (
        <div className="leading-tight">
          <div className="font-extrabold tracking-tight text-[15px] sm:text-base tulsi-text-gradient">
            Tulsi Sales OS
          </div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-neutral-500">SFA • ERP</div>
        </div>
      )}
    </div>
  );
}
